import { graphql } from '../../../graphql/generated';

export const UPDATE_THEME_MUTATION = graphql(`
  mutation UpdateTheme($id: ID!, $input: ThemeInput!) {
    updateTheme(id: $id, input: $input) {
      id
    }
  }
`);
